
import {defineComponent} from "vue";

export default defineComponent({
  name: 'CookiePolicyPage',
  props: {
    serviceCode: {
      type: String,
      required: true
    }
  },
  setup: function () {
    return {}
  }
})
